module.exports = __webpack_public_path__ + "static/img/train-img.2614916f.png";